import { useEffect, useState } from "react";
import { Activity, Bot, Clock, Users, Wallet, Link2 } from "lucide-react";
import { Stat } from "../../components/common";
import { api, date, idr } from "../../lib/api";

export default function AdminOverview({ go }) {
  const [s, setS] = useState(null);
  const [members, setMembers] = useState([]);
  useEffect(() => {
    api.get("/admin/summary").then((r) => setS(r.data));
    api.get("/admin/members").then((r) => setMembers(r.data));
  }, []);
  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">ADMIN CONSOLE</p><h2>Ringkasan platform</h2><p className="muted">Pantau member, pembayaran, dan konektor broker.</p></div>
        <button className="primary" onClick={() => go("admin-payments")} data-testid="admin-goto-payments"><Clock size={16} /> {s?.pending ?? 0} menunggu verifikasi</button>
      </div>
      <div className="stats-grid three">
        <Stat testId="admin-stat-members" label="Member" value={s?.members ?? 0} hint={`${s?.accounts ?? 0} akun trading`} icon={Users} />
        <Stat testId="admin-stat-revenue" label="Pendapatan terverifikasi" value={idr(s?.revenue)} hint={`${s?.active_rentals ?? 0} sewa EA aktif`} icon={Wallet} />
        <Stat testId="admin-stat-commissions" label="Komisi affiliate" value={idr(s?.commissions)} hint="5% dari sewa EA" icon={Link2} />
      </div>
      <section className="panel table-panel">
        <div className="panel-head"><h3>Member terbaru</h3><Activity size={16} /></div>
        <div className="table-row table-head"><span>NAMA</span><span>KONTAK</span><span>REFERRAL DARI</span><span>BERGABUNG</span></div>
        {members.slice(0, 20).map((m) => (
          <div className="table-row" key={m.id} data-testid={`admin-member-${m.id}`}>
            <span>{m.name} {m.role === "admin" && <small className="pill ok">admin</small>}</span>
            <span>{m.email}<small className="muted block">{m.phone}</small></span>
            <span>{m.referred_by_name || "—"}</span>
            <span>{date(m.created_at)}</span>
          </div>
        ))}
        {members.length === 0 && <p className="muted pad-y"><Bot size={14} /> Belum ada member.</p>}
      </section>
    </>
  );
}
